/**
 * Normalizes a loose orientation input into the canonical `CW{deg}` form the
 * engine understands. Accepts:
 *
 * - `"CW0"`, `"CW90"`, `"CW180"`, `"CW270"` (case-insensitive, separators stripped)
 * - the bare degree numbers `0`, `90`, `180`, `270` (string or number)
 * - the index forms `0`, `1`, `2`, `3` (string or number)
 *
 * Unrecognized input falls back to {@link fallback} (default `"CW0"`).
 *
 * @param {unknown} value
 * @param {Orientation} [fallback]
 * @returns {Orientation}
 */
export function normalizeOrientation(value, fallback = "CW0") {
    const normalized = String(value ?? "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (normalized === "0" || normalized === "CW0")
        return "CW0";
    if (normalized === "1" || normalized === "90" || normalized === "CW90")
        return "CW90";
    if (normalized === "2" || normalized === "180" || normalized === "CW180")
        return "CW180";
    if (normalized === "3" || normalized === "270" || normalized === "CW270")
        return "CW270";
    return fallback;
}
/**
 * CSS `transform` value for an orientation. Empty string for `"CW0"`.
 *
 * @param {Orientation} orientation
 * @returns {string}
 */
export function cssRotationForOrientation(orientation) {
    if (orientation === "CW90")
        return "rotate(90deg)";
    if (orientation === "CW180")
        return "rotate(180deg)";
    if (orientation === "CW270")
        return "rotate(270deg)";
    return "";
}
//# sourceMappingURL=orientation.js.map